<template>
  <div>
    <el-table :data="tableData" border>
      <el-table-column v-for="(headerItem) in tableHeader" :key="headerItem.prop" :prop="headerItem.prop"
                       :width="headerItem.width" :label="headerItem.label">
        <template v-slot="scope">
          <template v-if="headerItem.type === 1">{{ scope.row[headerItem.prop] | formatTime }}</template>
          <template v-else-if="headerItem.type === 2">
            <el-tag>{{ scope.row[headerItem.prop] }}</el-tag>
          </template>
          <template v-else-if="headerItem.type === 3">{{ userIdToNameMap[scope.row[headerItem.prop]] }}</template>

          <template v-else>{{ scope.row[headerItem.prop] }}</template>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager">
      <el-pagination layout="sizes, prev, pager, next" :total="totalCount" :page-sizes="pageSizes"
                     :page-size.sync="curPageSize" :pager-count="5"
                     :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getListOperate} from '@/api/log-api'
import {mixin_page_table} from "@/utils/mixin";
import {getAllAccount} from "@/api/account-api";

export default {
  name: "OperationLog",
  mixins: [mixin_page_table],
  data() {
    return {
      tableHeader: [
        {prop: 'id', label: '序号', width: 80, type: 0},
        {prop: 'accountId', label: '操作账号', width: 140, type: 3},
        {prop: 'type', label: '操作类型', width: 100, type: 2},
        {prop: 'request', label: '请求参数', width: '', type: 0},
        {prop: 'response', label: '响应参数', width: '', type: 0},
        {prop: 'time', label: '时间', width: 200, type: 1},
      ],
      userIdToNameMap: {},
    }
  },

  filters: {
    formatTime(time) {
      const date = new Date(time);
      const year = date.getFullYear().toString().slice(-2);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
  },

  mounted() {
    this.doGetAllAccount()
  },
  methods: {
    refreshTableData() {
      this.tableData = []
      let pageIndex = this.curPageIndex
      let pageSize = this.curPageSize

      getListOperate(pageIndex, pageSize).then(({data}) => {
        console.log("getListOperate", data)
        if (data.code === 200) {
          this.tableData = data.data.data
          this.totalCount = data.data.totals
        } else {
          this.$message.error(data.msg)
          this.showServerErrMsg(data.msg)
        }
      }).catch(err => {
        console.log(err)
        this.showNetErrMsg()
      })

    },

    doGetAllAccount() {
      getAllAccount().then(({data}) => {
        console.log("getAllAccount", data)
        if (data.code === 200) {
          data.data.forEach(item => {
            this.userIdToNameMap[item.id] = item.name
          })
        } else {
          this.$message.error(data.msg)
          this.showServerErrMsg(data.msg)
        }
        this.refreshTableData()
      }).catch(err => {
        console.log(err)
        this.showNetErrMsg()
        this.doGetListOperate()
      })
    },
  }
}
</script>


<style scoped lang="less">
.el-table {
  //max-height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>
